import type { EnrichedParticipants } from '@ps/isp-web-services-types';
import isNumber from 'lodash/isNumber';
import React from 'react';

import type { FootballFixture } from '@swf/generated/graphql/scoreboards/schemas';

import Score, { Team } from '../Score/Score';

import styles from './FootballScoreboard.scss';

interface Props {
  participants: EnrichedParticipants;
  footballFixture: FootballFixture;
  isValidInPlayStatus?: boolean;
}

const FootballScoreboard: React.FC<Props> = ({
  participants,
  footballFixture,
  isValidInPlayStatus
}) => {
  const [teamA, teamB] = participants.map(({ participant }) => participant);
  const { score, penaltyShootout } = footballFixture;

  return (
    <div data-testid="football-scoreboard">
      <div className={styles.team}>
        <Score
          team={Team.HOME}
          score={score && isNumber(score.home) ? `${score.home}` : undefined}
          isValidInPlayStatus={isValidInPlayStatus}
          isPenaltyShootout={Boolean(penaltyShootout)}
        />
        <span className={styles.name}>{teamA}</span>
      </div>
      <div className={styles.team}>
        <Score
          team={Team.AWAY}
          score={score && isNumber(score.away) ? `${score.away}` : undefined}
          isValidInPlayStatus={isValidInPlayStatus}
          isPenaltyShootout={Boolean(penaltyShootout)}
        />
        <span className={styles.name}>{teamB}</span>
      </div>
    </div>
  );
};

export default FootballScoreboard;
